import { NgClass, NgStyle } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/core/services/user.service';
import { User } from 'app/shared/interfaces/UserInterface';
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [NgClass, NgStyle],
})
export class AvatarComponent implements OnInit {
    public file = '';
    public loading: boolean;
    public user: User;
    constructor(private userService: UserService) {}

    ngOnInit(): void {
        this.user = this.userService.user;
        this.file = this.user.profile_image
            ? '/users-images/' + this.user.profile_image
            : '../../../../assets/app/media/img/users/user-128.png';
    }
}
